<section [ngClass]="isPdfExport() ? 'pdf-table-container' : 'table-container'">
  <table mat-table [dataSource]="dataSource">

    <!-- name column -->
    <ng-container [matColumnDef]="isPdfExport() ? 'itemNamePDF' : 'itemName'">
      <th mat-header-cell *matHeaderCellDef class=" border-bottom border-right">Items</th>
      <td mat-cell *matCellDef="let row" class="border-right">
        <div class="item-cell">
          <div class="item-title">
            <div class="category-icon"><app-custom-icon [customIcon]="row.controls.icon.value"
            class="category-icon"></app-custom-icon></div>
            <span [ngClass]="{'pdf': isPdfExport()}">{{row.controls.itemName.value}}</span>
          </div>
        </div>
      </td>
    </ng-container>

    <!-- dynamic columns for each stakeholder's ratings -->
    @if (!isPdfExport()) {
      @for (stakeholder of stakeholders; track stakeholder) {
        <ng-container [matColumnDef]="'evaluation.' + stakeholder.userId">
          <th mat-header-cell mat-header-cell *matHeaderCellDef class="border-bottom ">{{ stakeholder.name }}</th>
          <td mat-cell mat-cell *matCellDef="let row">
            <div class="score-cell">
              {{ convertScoreToPlusMinusScore(row.value.evaluations[stakeholder.userId ?? 0] ?? null) }}
            </div>
          </td>
        </ng-container>
      }
    }

    <!-- avgEvaluation column -->
    @if (!isPdfExport()) {
      <ng-container matColumnDef="avgEvaluation">
        <th mat-header-cell mat-header-cell *matHeaderCellDef class="border-left border-bottom">Gemiddelde score</th>
        <td mat-cell mat-cell *matCellDef="let row" class="endSticky border-left theme">
          <div class="score-cell">
            {{ convertScoreToPlusMinusScore(row.controls.avgEvaluation.value) }}
          </div>
        </td>
      </ng-container>
    }

    <!-- consensus column -->
    <ng-container [matColumnDef]="isPdfExport() ? 'finalScorePDF' : 'finalScore'">
      <th mat-header-cell mat-header-cell *matHeaderCellDef class="border-bottom">Consensus</th>
      <td mat-cell mat-cell *matCellDef="let row" class="endSticky theme">
        <div class="consensus-cell">

          @if (!isPdfExport()) {
            <mat-form-field appearance="fill" class="consensus-input">
              <mat-select [formControl]="row.controls.finalScore" aria-label="Scoren selecteren" role="listbox" >
                <mat-option [value]="0" class="score-option" default>?</mat-option>
                <mat-option [value]="1" class="score-option">−−</mat-option>
                <mat-option [value]="2" class="score-option">−</mat-option>
                <mat-option [value]="3" class="score-option">−/+</mat-option>
                <mat-option [value]="4" class="score-option">+</mat-option>
                <mat-option [value]="5" class="score-option">++</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (isPdfExport()) {
            <div>
              <span>{{convertScoreToPlusMinusScore(row.controls.finalScore.value, true)}}</span>
            </div>
          }

        </div>
      </td>
    </ng-container>
    <!-- conclusion column -->
    <ng-container [matColumnDef]="isPdfExport() ? 'finalUnderpinningPDF' : 'finalUnderpinning'">
      <th mat-header-cell mat-header-cell *matHeaderCellDef class="border-bottom">Conclusie</th>
      <td mat-cell mat-cell *matCellDef="let row" class="endSticky theme">
        <div class="conclusion-cell">
          @if (!isPdfExport()) {
            <mat-form-field>
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" #autosize="cdkTextareaAutosize"
              [formControl]="row.controls.finalUnderPinning" maxlength="1000"></textarea>
            </mat-form-field>
          }
          @if (isPdfExport()) {
            <div>
              <span>{{row.controls.finalUnderPinning.value ?? 'geen conclusie'}}</span>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row mat-row *matRowDef="let row; columns: displayedColumns;" [class]="row.controls.category.value  + '-theme'" ></tr>

  </table>
</section>
